import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { t } from '@fetmode/i18n';
import { Navigate, useParams } from 'react-router-dom';

import { useAuth } from '../auth/index.js';

/** Forwards legacy `/videos/:mediaId` (UUID) URLs to the canonical
 *  creator-scoped `/@creator/v/{slug}` path so no GUID stays in the bar. */
export function LegacyVideoRedirect(): ReactElement {
  const { mediaId } = useParams<{ mediaId: string }>();
  const { api } = useAuth();
  const [target, setTarget] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!mediaId) {
      setFailed(true);
      return;
    }
    let active = true;
    void api
      .getMediaItem(mediaId)
      .then((result) => {
        if (active) {
          setTarget(`/@${result.item.model.username}/v/${result.item.slug}`);
        }
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [api, mediaId]);

  if (target) {
    return <Navigate to={target} replace />;
  }
  if (failed) {
    return <Navigate to="/videos" replace />;
  }
  return <p style={{ color: 'var(--fm-color-text-muted)' }}>{t('common.videos.loading')}</p>;
}
